import { render, staticRenderFns } from "./User.Menu.AddForm.vue?vue&type=template&id=4dc9d1a4&"
import script from "./User.Menu.AddForm.vue?vue&type=script&lang=js&"
export * from "./User.Menu.AddForm.vue?vue&type=script&lang=js&"
import style0 from "./User.Menu.AddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports